var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProfileEmpHeader',{attrs:{"img_header":_vm.header_image,"header":"จัดการข้อมูลส่วนตัว (Manage personal information)"}}),_c('Profile_Emp_Manage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }